module.exports = __webpack_public_path__ + "img/certificate10.723c2013.jpg";